module.exports = __webpack_public_path__ + "img/7Koepfe.2b46c2c1.svg";